module.exports = __webpack_public_path__ + "static/media/times.4c77ea01.svg";